import React from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { AnalyticEvents } from '@constants/index';
import { Analytics } from '@services/analytics-service';
import { Button } from '@carvana/core-helios-button';
import { useRepairFacilities } from '@components/service-and-repair/providers/repair-facilities';
import { isCarvanaNativeApp } from '@carvana/core-native-messaging';
import { sendNativeMessage, NativeMessageEvent } from '@components/_common/link/link';
import styles from './coverage.module.css';
import { generateKey, CoveragePageProps } from './coverage-screen';
import { useRouter } from '../../providers/router';
import { PreferredPartnerForm } from '../service-repair-center/preferred-partner-form';
import ResultTile from '../service-repair-center/result-tile';
import ExternalLink from '../service-repair-center/icons/external-link';

export const Sorry = (props: CoveragePageProps) => {
  const { button, description, outboundLinks, title, showPreferredPartnersForm } = props || {};
  const { closeModal } = useRouter();
  const { isLoading: isSearching, repairFacilities } = useRepairFacilities();
  const repairFacilitiesCount = repairFacilities?.length || 0;
  const hideTreatmentViewMoreCTA = showPreferredPartnersForm && repairFacilitiesCount > 2;
  const isButtonViewMore = button?.text?.toLowerCase()?.includes('view more');

  const primaryCtaOnClick = () => {
    if (button?.closeModal) {
      closeModal();
      return;
    }

    Analytics.trackEvent(AnalyticEvents.sarCoverageScreenClickedBottomButton, {
      buttonName: button?.text,
    });
    datadogRum.addAction(AnalyticEvents.sarCoverageScreenClickedBottomButton, {
      buttonName: button?.text,
    });

    if (isCarvanaNativeApp()) {
      sendNativeMessage('link' as NativeMessageEvent, {
        url: button?.link,
      });
    } else {
      window.open(button?.link, '_blank');
    }
  };

  return (
    <div className={styles['coverage-page-wrapper']}>
      <div className={styles['coverage-header-wrapper']}>
        <div className={styles['header']}>{title}</div>
        <div className={styles['header-paragraph-wrapper']}>
          {Array.isArray(description)
            ? description.map((desc) => (
                <p key={generateKey()} className={styles['paragraph']}>
                  {desc}
                </p>
              ))
            : description}
        </div>
      </div>

      {showPreferredPartnersForm && <PreferredPartnerForm heading="Recommended shops near you" />}

      {!showPreferredPartnersForm &&
        outboundLinks?.map((link) => (
          <ResultTile
            name={link.title}
            key={link.title}
            description={link.description}
            website={link.link}
            buttonType={link.buttonType}
            disclaimer={link.disclaimer}
          />
        ))}

      <div className={styles['coverage-button-wrapper']}>
        {!hideTreatmentViewMoreCTA && button && !isSearching && !isButtonViewMore && (
          <Button
            priority={(button?.buttonType as any) || 'primary'}
            iconRight={button?.viewMoreButton && <ExternalLink />}
            className={button?.viewMoreButton ? styles['view-more-shops'] : ''}
            onClick={() => primaryCtaOnClick()}
          >
            {button?.text}
          </Button>
        )}
      </div>
    </div>
  );
};
